@if (isLoading) {
  <div class="flex justify-center">
    @if (isLoading) {
      <p-progressSpinner></p-progressSpinner>
    }
  </div>
}
@if (!isLoading) {
  <div>
    <div class="flex items-center gap-4 mb-4">
      <button
        type="button"
        pButton
        icon="pi pi-arrow-left"
        [rounded]="true"
        [text]="true"
        (click)="goBack()"
      >
      </button>
      <div>
        <p class="font-bold">{{ user?.firstName }} {{ user?.lastName }}</p>
        <p [class]="{ 'text-red-400': !user?.isActive }">
          {{ user?.isActive ? 'Active User' : 'Inactive User' }}
        </p>
      </div>
      <button type="button"
              pButton
              class="ml-4"
              label="{{ !user.isActive ? 'Activate User' : 'Deactivate User' }}"
              [appChangeUserStatus]="user"
              [accessEnableSubmit]="['ExternalUser.Write']">
        <i class="pi pi-power-off icon-color p-button-icon-left"></i>
      </button>
      @if (isChangeUserEnabled) {
        <div class="flex gap-2 ml-auto">
          <ng-container *accessView="['AdminPage.UI.Read']">
            <button
              pButton
              type="button"
              class="ml-auto p-button-outlined"
              label="Change User Type"
              (click)="changeUserType()"
            ></button>
          </ng-container>
        </div>
      }
    </div>
    <div class="mb-4">
      <form [formGroup]="form">
        <div class="p-form-widget grid grid-cols-12 gap-4 p-fluid pl-2">
          <div class="col-span-4">
            <div class="flex items-center gap-4">
              <label class="field-required text-neutral-700">First Name:</label>
              <div class="grow">
                <input pInputText type="text" formControlName="givenName" class="w-full" maxlength="50" />
              </div>
            </div>
          </div>
          <div class="col-span-4">
            <div class="flex items-center gap-4">
              <label class="field-required text-neutral-700">Last Name:</label>
              <div class="grow">
                <input pInputText type="text" formControlName="surname" class="w-full" maxlength="50" />
              </div>
            </div>
          </div>
          <div class="col-span-4">
            <div class="flex items-center gap-4">
              <label class="text-neutral-700">Business Email:</label>
              <div class="grow">
                <input pInputText type="text" formControlName="otherMails" class="w-full" maxlength="50" />
              </div>
            </div>
          </div>
          <div class="col-span-4 fluid">
            <div class="flex items-center gap-4">
              <label class="text-neutral-700">Credentials:</label>
              <div class="grow">
                <input pInputText type="text" formControlName="credentials" class="w-full" maxlength="50" />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="flex justify-end">
      <ng-container *accessView="['ExternalUser.Write']">
        <button
          type="button"
          severity="info"
          pButton
          label="Cancel"
          (click)="onCancel()"
          class="mr-2"
          [disabled]="!form?.dirty || !isFormChanged"
        ></button>
        <button
          type="submit"
          pButton label="Save"
          (click)="onSave()"
          class="p-button-action"
          [disabled]="canSaveUser"
        ></button>
      </ng-container>
    </div>
  </div>
}

<p-confirmDialog
  header="Confirmation"
  appendTo="body"
  [style]="{width: '398px'}"
  [rejectIcon]="''"
  [acceptIcon]="''"
  [rejectButtonStyleClass]="'p-button-secondary'"
></p-confirmDialog>
<p-toast key="saved" position="bottom-left"></p-toast>
<p-confirmDialog
  key="unsavedChanges"
  appendTo="body"
  rejectIcon="''"
  acceptIcon="''"
  rejectButtonStyleClass="p-button-secondary"
  acceptButtonStyleClass="p-button-warning"
  [style]="{width: '398px'}"
></p-confirmDialog>
